import React from 'react';
import { HomeIcon, CreditCardIcon, SettingsIcon, QrCodeIcon } from 'lucide-react';
type Screen = 'home' | 'payments' | 'cards' | 'rewards' | 'more';
interface BottomNavProps {
  activeScreen: Screen;
  onNavigate: (screen: Screen) => void;
}
export function BottomNav({
  activeScreen,
  onNavigate
}: BottomNavProps) {
  const navItems = [{
    id: 'home' as Screen,
    icon: HomeIcon
  }, {
    id: 'payments' as Screen,
    icon: QrCodeIcon
  }, {
    id: 'cards' as Screen,
    icon: CreditCardIcon
  }, {
    id: 'more' as Screen,
    icon: SettingsIcon
  }];
  return <nav className="fixed bottom-0 left-0 right-0 bg-white rounded-t-[32px] shadow-[0_-10px_40px_rgba(0,0,0,0.05)] safe-area-bottom z-50" data-id="element-18">
      <div className="max-w-[430px] mx-auto flex justify-around items-center h-20 px-6" data-id="element-19">
        {navItems.map(item => {
        const isActive = activeScreen === item.id;
        const Icon = item.icon;
        return <button key={item.id} onClick={() => onNavigate(item.id)} className="relative flex items-center justify-center w-14 h-14 transition-all" data-id="element-20">
              {isActive && <div className="absolute inset-0 bg-[#D95A1A] rounded-[20px] shadow-sm" data-id="element-21" />}
              <Icon className={`w-6 h-6 relative z-10 transition-colors ${isActive ? 'text-white' : 'text-[#A89F98]'}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-22" />
            </button>;
      })}
      </div>
    </nav>;
}